export enum HttpStatus {
  OK = 200,
  Unauthorized = 401,
  Forbidden = 403,
  RateLimit = 429,
}
